import EmObject, { computed } from '@ember/object';
import { CampaignState, CampaignType } from 'cio/models/campaign';

export const ALL_NEWSLETTERS = 'all';
export const ALL_CHANNELS = 'all';

class Filter extends EmObject {
  name = '';
  analyticsName = '';
  value = '';
  count = 0;
  icon: string | null = null;
  showCount = true;

  @computed('name', 'count', 'showCount')
  get label() {
    if (this.showCount) {
      return `${this.name} (${this.count})`;
    } else {
      return `${this.name}`;
    }
  }
}

export const CAMPAIGN_FILTERS = [
  Filter.create({
    name: 'All',
    analyticsName: 'All campaigns',
    value: 'null',
    showCount: false,
  }),
  Filter.create({
    name: 'Segment',
    analyticsName: 'Segment triggered',
    value: CampaignType.Behavioral,
    showCount: false,
    icon: 'trigger-segment',
  }),
  Filter.create({
    name: 'Event',
    analyticsName: 'Event triggered',
    value: CampaignType.Transactional,
    showCount: false,
    icon: 'trigger-event',
  }),
  Filter.create({
    name: 'Form',
    analyticsName: 'Form triggered',
    value: CampaignType.Form,
    showCount: false,
    icon: 'form',
  }),
  Filter.create({
    name: 'Date',
    analyticsName: 'Date triggered',
    value: CampaignType.Date,
    showCount: false,
    icon: 'calendar',
  }),
  Filter.create({
    name: 'Webhook',
    analyticsName: 'Webhook triggered',
    value: CampaignType.Webhook,
    showCount: false,
    icon: 'webhook',
  }),
  Filter.create({
    name: 'Object',
    analyticsName: 'Object triggered',
    value: CampaignType.Object,
    showCount: false,
    icon: 'object',
  }),
  Filter.create({
    name: 'Relationship',
    analyticsName: 'Relationship triggered',
    value: CampaignType.ObjectRelationship,
    showCount: false,
    icon: 'connections',
  }),
];

// relevant to ID-based workspaces, will change when we introduce form campaigns to them:
export const CAMPAIGN_FILTERS_WITHOUT_FORM_TRIGGERED = CAMPAIGN_FILTERS.filter((f) => f.value !== CampaignType.Form);

export const NEWSLETTER_FILTERS = [
  Filter.create({
    name: 'All newsletters',
    value: ALL_NEWSLETTERS,
  }),
  Filter.create({
    name: 'Drafted',
    value: 'drafted',
    icon: 'draft',
  }),
  Filter.create({
    name: 'Sent',
    value: 'sent',
    icon: 'send-auto',
  }),
  Filter.create({
    name: 'Scheduled',
    value: 'scheduled',
    icon: 'time-window',
  }),
];

export const CAMPAIGN_STATE_FILTERS: Partial<Record<CampaignState, CampaignState[]>> = {
  [CampaignState.Running]: [CampaignState.Running],
  [CampaignState.Draft]: [CampaignState.Draft],
  [CampaignState.Stopped]: [
    CampaignState.Stopped,
    CampaignState.Sunsetting,
    CampaignState.Stopping,
    CampaignState.Unarchiving,
  ],
};
